import { render, staticRenderFns } from "./LegacyDeviceManagementWizard.vue?vue&type=template&id=8724b006&"
import script from "./LegacyDeviceManagementWizard.vue?vue&type=script&lang=js&"
export * from "./LegacyDeviceManagementWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports